import { onMounted } from 'vue'
import useGet from '@/core/composables/api/useGet'
import type { Member } from '@/core/models/member/member'
import type { CoachFeedbackGoalTopic } from './use-coach-feedback-goal'

export interface CoachFeedbackGoalPreview {
  readonly id: string
  readonly feedbackTopic: CoachFeedbackGoalTopic
  readonly isActive: boolean
  readonly perspectiveTargets: ReadonlyArray<{
    readonly perspectiveKey: string
    readonly target: number
  }>
  readonly coachees: ReadonlyArray<Member>
}

export const useCoachFeedbackGoals = () => {
  const { data, status, load, reload } =
    useGet<CoachFeedbackGoalPreview[]>('coaching/feedback-goals')

  onMounted(() => {
    load()
  })

  return {
    feedbackGoals: data,
    status,
    reload,
  }
}
